import { render, staticRenderFns } from "./paymentsNew.vue?vue&type=template&id=03d57d46&"
import script from "./paymentsNew.vue?vue&type=script&lang=js&"
export * from "./paymentsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports